import { faRobot, faSparkles, faUser } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { memo } from "react";
import Markdown from 'react-markdown'
import Loader from "components/Loading/Loader";
import { Flex } from "antd";

import './BotMessage.sass';

const BotMessageBase = (props) => {

    const content = props?.content || props.children;
    const role = props.role || "bot";
    const loading = props.loading || false;

    return (
        <Flex vertical={false} className="BotMessage">
            {role === "assistant" && <div className="bot">
                <FontAwesomeIcon icon={faSparkles} />
            </div>
            }
            <div className="message w-100">
                {role === "assistant" && content && !props.children ? <Markdown>{content}</Markdown> : content}
                {loading && <div style={{ height: "50px" }}><Loader size={30} style={{ minHeight: "50px" }}></Loader></div>}
            </div>
            {role === "user" && <div className="user">
                <FontAwesomeIcon icon={faUser} />
            </div>}
        </Flex>
    );
};

export const BotMessage = memo(BotMessageBase, (prev, next) =>
    prev.content === next.content &&
    prev.role === next.role &&
    prev.loading === next.loading &&
    prev.children === next.children
);